import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Logo from "../assets/logo.png";
import { notify } from "react-notify-toast";
import { data } from "./Icons";
import Dropdown from "./dropdown";
export default function Leftnav() {
  const [opened, setState] = useState(true);
  const [role, setRole] = useState(null);
  const [icons, setIcons] = useState(null);
  const history = useHistory();
  useEffect(() => {
    let payload = localStorage.getItem("Ubytes");
    if (payload) {
      setRole(JSON.parse(payload).role);
      setIcons(data[role]);
    }
  });
  const logOut = () => {
    localStorage.removeItem("Ubytes");
    notify.show("Log out successful!", "success");
    window.location = window.origin;
  };
  if (!localStorage.getItem("Ubytes")) {
    return null;
  }
  return (
    <div
      className="lef-nav-parent"
      style={{ width: `${opened ? "12.8rem" : "4rem"}` }}
    >
      <div className={opened ? "left-nav-body-opened" : "left-nav-body-closed"}>
        <div className="left-nav-toggle" onClick={() => setState(!opened)}>
          <i class="fas fa-chevron-left"></i>
        </div>
        <div className="left-nav-section-wrapper">
          <div className="left-nav-upper">
            <div
              className="left-nav-brand"
              style={{ backgroundColor: "whitesmoke" }}
            >
              {opened ? (
                <img style={{ width: "85%", height: "45px" }} src={Logo}></img>
              ) : (
                <p
                  style={{
                    color: "black",
                    fontSize: "large",
                    fontWeight: "bold",
                  }}
                >
                  U
                </p>
              )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <div>
              {icons
                ? icons.map((icon) =>
                    icon.isMulti ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="button-tooltip-2">{icon.name}</Tooltip>
                        }
                      >
                        <Dropdown items={icon.children}>
                          <Link
                            to={icon.route}
                            style={{ textDecoration: "none", width: "100%" }}
                          >
                            <div class={"left-nav-section"}>
                              <div className="left-nav-icons">{icon.icon}</div>
                              {opened ? (
                                <h5 style={{ color: "white" }}>{icon.name}</h5>
                              ) : null}
                              <div
                                style={{
                                  display: "flex",
                                  width: "100%",
                                  justifyContent: "flex-end",
                                  marginRight: "10px",
                                }}
                              >
                                {" >"}
                              </div>
                            </div>
                          </Link>
                        </Dropdown>
                      </OverlayTrigger>
                    ) : (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="button-tooltip-2">{icon.name}</Tooltip>
                        }
                      >
                        <Link
                          to={icon.route}
                          style={{ textDecoration: "none" }}
                        >
                          <div class={"left-nav-section"}>
                            <div className="left-nav-icons">{icon.icon}</div>
                            {opened ? (
                              <h5 style={{ color: "white" }}>{icon.name}</h5>
                            ) : null}
                          </div>
                        </Link>
                      </OverlayTrigger>
                    )
                  )
                : null}
            </div>
            <div
              class="left-nav-section"
              style={{ float: "bottom" }}
              onClick={logOut}
            >
              <div className="left-nav-icons">
                <i class="fas fa-power-off"></i>
              </div>
              {opened ? <h5 style={{ color: "white" }}>Logout</h5> : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
